import { render, staticRenderFns } from "./DownloadDataBtn.vue?vue&type=template&id=b209d116&scoped=true&"
import script from "./DownloadDataBtn.vue?vue&type=script&lang=js&"
export * from "./DownloadDataBtn.vue?vue&type=script&lang=js&"
import style0 from "./DownloadDataBtn.vue?vue&type=style&index=0&id=b209d116&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b209d116",
  null
  
)

export default component.exports